import { replaceDoubleSlashWithSingleSlash } from "@enfusion-ui/utils";
import { DASHBOARD_LATEST_CONFIG_VERSION } from "../constants";
import DOCUMENTS_API from "./documents";
const DASHBOARD = "dashboard";
export default (restServer) => {
    const documentsAPI = DOCUMENTS_API(restServer);
    return {
        GET_ROOT_NODE: documentsAPI.GET_ROOT_NODE.bind(this, DASHBOARD),
        GET_SEARCH_ROOT_NODE: documentsAPI.GET_SEARCH_ROOT_NODE.bind(this, DASHBOARD),
        GET_ROOT_NODE_FACTORY: () => documentsAPI.GET_ROOT_NODE_FACTORY(DASHBOARD),
        CREATE_FOLDER: (root, filePath) => documentsAPI.CREATE_FOLDER(DASHBOARD, `${root}/${filePath}`),
        RENAME_FOLDER: (filePath, newFolderName, forceWrite) => documentsAPI.RENAME_FOLDER(DASHBOARD, filePath, newFolderName, forceWrite),
        DELETE_ENTRY: (filePath) => documentsAPI.DELETE_ENTRY(DASHBOARD, filePath),
        MOVE_ENTRY: (filePath, destinationFolder, forceWrite) => documentsAPI.MOVE_ENTRY(DASHBOARD, filePath, destinationFolder, forceWrite),
        DOWNLOAD: (filePath, root = "dashboard", mobile, abortController) => documentsAPI.DOWNLOAD(root, filePath, mobile, abortController),
        STORE_DASHBOARD: ({ path, rootPath, name, version, config, settings, configVersion = DASHBOARD_LATEST_CONFIG_VERSION, datasources, forceWrite = false, }, root = "dashboard", mobile) => documentsAPI.UPLOAD(root, rootPath, {
            path: replaceDoubleSlashWithSingleSlash(`/${path}/`),
            forceWrite,
            content: {
                name,
                version,
                config,
                settings,
                configVersion,
                datasources,
            },
        }, mobile),
    };
};
